module.exports = __webpack_public_path__ + "img/certificate-IM-outstanding.24f44b84.png";